import React, { useCallback, useMemo } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { OutputCell } from '../../common/Output';
import { ProgramRequestLike } from './ProgramRequestLike';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Zoom, Navigation, History, Virtual } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/zoom';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './program-request-page.css';

const defaultImage =
    'data:image/svg+xml;utf8,<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="grin-alt" class="svg-inline--fa fa-grin-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="rgb(108, 117, 125)" d="M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"></path></svg>';

function ProgramRequestContent(props) {
    const { reqItem } = props;
    const durSeconds = +reqItem.duration % 60;
    const durMinutes = (+reqItem.duration - durSeconds) / 60;
    return (
        <Container>
            <h1 className="text-center mt-3 mb-1">
                <span className="d-none d-sm-inline">Выступление</span> №{reqItem.requestNum}
            </h1>
            <h3 className="text-center mt-0 mb-3 font-weight-light">
                <span className="d-none d-sm-inline">Номинация:</span> {reqItem.nomination}
            </h3>
            <Card>
                <div className="swiper-zoom-container">
                    <img
                        alt=""
                        src={reqItem.image || defaultImage}
                        className="card-img-top bg-white"
                        loading="lazy"
                        onError={(e) => (e.target.src = defaultImage)}
                    />
                </div>
                <Card.Body className="invis_on_zoomed text-left">
                    <Row className="my-0 align-items-center">
                        <Col className="font-weight-bold" xs={6} sm={5} md={4} lg={3}>
                            Ваш голос:
                        </Col>
                        <Col xs={6} sm={7} md={8} lg={9}>
                            <ProgramRequestLike requestId={reqItem.requestId} />
                        </Col>
                    </Row>
                    <Row className="my-0">
                        <Col className="font-weight-bold" xs={6} sm={5} md={4} lg={3}>
                            Время выхода:
                        </Col>
                        <Col xs={6} sm={7} md={8} lg={9}>
                            {reqItem.startTime}
                        </Col>
                    </Row>
                    <Row className="my-0">
                        <Col className="font-weight-bold" xs={6} sm={5} md={4} lg={3}>
                            Длительность:
                        </Col>
                        <Col xs={6} sm={7} md={8} lg={9}>
                            {durMinutes} мин {durSeconds} сек
                        </Col>
                    </Row>
                    <Row className="my-0">
                        <Col className="font-weight-bold" sm={5} md={4} lg={3}>
                            {reqItem.users && reqItem.users.length > 1 ? 'Выступающие' : 'Выступающий'}:
                        </Col>
                        <Col sm={7} md={8} lg={9}>
                            {reqItem.participant}
                        </Col>
                    </Row>
                    {(reqItem.fields &&
                        reqItem.fields.length &&
                        reqItem.fields.map((field) => (
                            <Row key={field.id} className="my-2 my-sm-0">
                                <Col className="font-weight-bold" sm={5} md={4} lg={3}>
                                    {field.name}:
                                </Col>
                                <Col sm={7} md={8} lg={9}>
                                    {field.value}
                                </Col>
                            </Row>
                        ))) ||
                        ''}
                    {(reqItem.users && reqItem.users.length && (
                        <Row className="my-3">
                            <Col xs={12}>
                                <Row className="d-none d-sm-flex mb-2 font-weight-bold">
                                    <Col sm={6} md={4} lg={3}>
                                        Участник
                                    </Col>
                                    <Col sm={6} md={8} lg={9}>
                                        Роль/персонаж
                                    </Col>
                                </Row>
                                {reqItem.users.map((user) => (
                                    <Row key={user.id} className="mb-2 pt-2 border-top">
                                        <Col sm={6} md={4} lg={3}>
                                            <OutputCell text={`${user.name} (${user.city})`} label="Участник" />
                                        </Col>
                                        <Col sm={6} md={8} lg={9}>
                                            <OutputCell text={user.role} label="Роль/персонаж" />
                                        </Col>
                                    </Row>
                                ))}
                            </Col>
                        </Row>
                    )) ||
                        ''}
                </Card.Body>
            </Card>
        </Container>
    );
}

function useProgramItems(program) {
    const { reqNum } = useParams();
    return useMemo(() => {
        if (!program || !program.items) return {};
        const items = [];
        let hasReq = false;
        program.items.forEach((dayItem) => {
            dayItem.items &&
                dayItem.items.forEach((blockItem) => {
                    blockItem.items &&
                        blockItem.items.forEach((groupOrReqItem) => {
                            if (groupOrReqItem.items) {
                                groupOrReqItem.items.forEach((requestItem) => {
                                    if (requestItem.requestNum) {
                                        items.push(requestItem);
                                        if (+requestItem.requestNum === +reqNum) hasReq = true;
                                    }
                                });
                            } else {
                                if (groupOrReqItem.requestNum) {
                                    items.push(groupOrReqItem);
                                    if (+groupOrReqItem.requestNum === +reqNum) hasReq = true;
                                }
                            }
                        });
                });
        });
        return { items, hasReq };
    }, [program, reqNum]);
}

function ProgramRequestPage() {
    const { program } = useSelector((state) => state.program);
    const { items, hasReq } = useProgramItems(program);
    const zoomChangeHandler = useCallback((swiper, scale) => {
        swiper.allowTouchMove = scale === 1;
    }, []);
    return (
        <>
            {items && hasReq ? (
                <Swiper
                    spaceBetween={50}
                    onSlideChange={() => console.log('slide change')}
                    onSwiper={(swiper) => console.log(swiper)}
                    modules={[Zoom, Navigation, History, Virtual]}
                    navigation={true}
                    zoom={true}
                    history={{
                        key: '',
                    }}
                    onZoomChange={zoomChangeHandler}
                >
                    {items.map((item, index) => (
                        <SwiperSlide key={item.id} data-history={item.requestNum} virtualIndex={index}>
                            <ProgramRequestContent reqItem={item} />
                        </SwiperSlide>
                    ))}
                    <Container className="back_button_container">
                        <Button
                            variant="link"
                            className="icon-button back_button"
                            title="Назад к программе"
                            as={Link}
                            to={`..`}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} size="2x" />
                        </Button>
                    </Container>
                </Swiper>
            ) : (
                <Container>
                    <Button
                        variant="link"
                        className="icon-button back_button"
                        title="Назад к программе"
                        as={Link}
                        to={`..`}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} size="2x" />
                    </Button>
                    <h2 className="text-center m-3">Нет такого выступления</h2>
                </Container>
            )}
        </>
    );
}

export default ProgramRequestPage;
